import type { GoogleCalendarTranslations } from '../interfaces/google-calendar';

export const googleCalendarTranslations: GoogleCalendarTranslations = {
  integrationSectionTitle: 'Google Calendar',
  integrationSectionDescription:
    'Connect your Google Calendar so {{brand}} can read and create events on your behalf.',
  connectedBadge: 'Connected',
  connectButton: 'Connect Calendar',
  redirectDisclaimer:
    "You'll be redirected to Google to grant access. Permissions can be revoked anytime.",
  configureButton: 'Configure',
  reconnectButton: 'Reconnect',
  disconnectButton: 'Disconnect',
  openCalendarButton: 'Open Google Calendar',

  emailAccountLabel: 'Connected account',
  primaryCalendarLabel: 'Primary calendar',
  lastSyncLabel: 'Last sync',
  watchExpiresLabel: 'Push channel expires',
  lastErrorLabel: 'Last warning from Google',

  drawerTitle: 'Google Calendar settings',
  drawerDescription:
    'Review the connected account, force a reconnection or disconnect {{brand}} from your calendar.',

  disconnectDialogTitle: 'Disconnect Google Calendar?',
  disconnectDialogDescription:
    '{{brand}} will stop reading your events. Synced events will remain in the database until you delete them manually.',
  disconnectDialogCancel: 'Cancel',
  disconnectDialogConfirm: 'Disconnect',

  successToast: 'Google Calendar connected successfully.',
  errorToast: 'Could not finish the Google Calendar connection.',
  disconnectedToast: 'Google Calendar disconnected.',

  errorTitle: 'Something went wrong ({{step}})',
  retryButton: 'Retry',
};
